import React from 'react';
import { useNavigate } from 'react-router-dom';
import PrescriptionsList from '../../components/PrescriptionsList';
import './PatientPrescriptions.css';

export default function PatientPrescriptions() {
  const navigate = useNavigate();

  return (
    <div className="patient-prescriptions-page">
      <div className="prescriptions-navbar">
        <button 
          className="back-button"
          onClick={() => navigate('/patient/home-new')}
          title="Back to dashboard"
        >
          ← 
        </button>
        <h1>💊 Prescriptions</h1>
        <div style={{ width: '40px' }}></div>
      </div>

      <div className="prescriptions-page-content">
        <PrescriptionsList />
      </div>

      <div className="prescriptions-info-banner">
        <p>
          <strong>✨ Auto-Sync:</strong> Prescriptions from your doctor are automatically added here when you log in. No need to search or download manually!
        </p>
      </div>
    </div>
  );
}
